import React from 'react';
import './sales-parameters.scss';
import { RootState } from '../../types';
import { useSelector } from 'react-redux';
import { BlockchainTransactionInfo } from 'components';

export default function SalesParameters() {
  const saleCfa: any = useSelector((state: RootState) =>
    state.operationsSign.data.saleCfa?.tokenName !== undefined
      ? state.operationsSign.data.saleCfa
      : state.operationsSign.data.sale
  );

  return (
    <div>
      <p className="p p_bold p_color_grey mb_24">Параметры продажи</p>
      {saleCfa.blockchainTransactionId && (
        <div className="mb_24">
          <p className="p p_font-size_12 p_color_light-grey mb_4">
            {saleCfa.status === 'APPLIED'
              ? 'ID транзакции (зачисление)'
              : ' ID транзакции (резервирование)'}
          </p>
          <BlockchainTransactionInfo hash={saleCfa.blockchainTransactionId} />
        </div>
      )}
      <div>
        <p className="p p_font-size_12 p_color_light-grey">
          Наименование токена
        </p>
        <p className="p p_color_light-blue mb_12">{saleCfa?.tokenName}</p>
      </div>
      <div>
        <p className="p p_font-size_12 p_color_light-grey">
          Количество продаваемых токенов
        </p>
        <p className="p p_color_grey mb_12">{saleCfa?.tokenCount}</p>
      </div>
      <div>
        <p className="p p_font-size_12 p_color_light-grey">
          Цена одного токена
        </p>
        <p className="p p_color_grey mb_12">{saleCfa?.tokenPrice} ₽</p>
      </div>
      <div>
        <p className="p p_font-size_12 p_color_light-grey">
          Общая цена продажи
        </p>
        <p className="p p_color_grey">{saleCfa?.paymentAmount} ₽</p>
      </div>
    </div>
  );
}
